import React from "react";
import cn from "classnames";
import * as css from "./loader.modules.scss";

const Loader = ({ className = "", ...rest }) => (
  <div className={cn(css.loader, className)} {...rest} />
);

export default Loader;
